"use strict";

var _defineProperty = require("/var/lib/jenkins/workspace/mr-learner-frontend-production/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/defineProperty");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getMergedStatus = void 0;
exports.getStatusClassNames = getStatusClassNames;

var _classnames = _interopRequireDefault(require("classnames"));

var InputStatuses = ['warning', 'error', ''];

function getStatusClassNames(prefixCls, status, hasFeedback) {
  var _ref;

  return (0, _classnames.default)((_ref = {}, _defineProperty(_ref, "".concat(prefixCls, "-status-success"), status === 'success'), _defineProperty(_ref, "".concat(prefixCls, "-status-warning"), status === 'warning'), _defineProperty(_ref, "".concat(prefixCls, "-status-error"), status === 'error'), _defineProperty(_ref, "".concat(prefixCls, "-status-validating"), status === 'validating'), _defineProperty(_ref, "".concat(prefixCls, "-has-feedback"), hasFeedback), _ref));
}

var getMergedStatus = function getMergedStatus(contextStatus, customStatus) {
  return customStatus || contextStatus;
};

exports.getMergedStatus = getMergedStatus;